const state = {
    courseTypeId: '',
}
const mutations = {
  SET_D201_PARAM: (state, param) => {
    state.courseTypeId = param.id;
  },
  CLEAR_D201_PARAM: (state) => {
    state.courseTypeId = "";
  }
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/d000201.js